module.exports = __webpack_public_path__ + "img/step1.383f8515.jpg";